var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessory191(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 188,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -13)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M162 54C162 73.8821 145.882 90.0001 126 90.0001 106.118 90.0001 90.0001 73.8821 90.0001 54 90.0001 34.1178 106.118 17.9999 126 17.9999 145.882 17.9999 162 34.1178 162 54Z",
    fill: "#4289C1",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 144.5C108 174.6 83.8234 199 54 199 24.1765 199 0 174.6 0 144.5 0 114.4 24.1765 90.0001 54 90.0001 83.8234 90.0001 108 114.4 108 144.5Z",
    fill: "#4289C1",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 72C108 101.824 83.8234 126 54 126 24.1765 126 0 101.824 0 72 0 42.1765 24.1765 17.9999 54 17.9999 83.8234 17.9999 108 42.1765 108 72Z",
    fill: "#4289C1",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 81.0001C144 105.853 123.853 126 99 126 74.147 126 54 105.853 54 81.0001 54 56.1472 74.147 36.0001 99 36.0001 123.853 36.0001 144 56.1472 144 81.0001Z",
    fill: "#4289C1",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 126C108 145.882 91.882 162 72 162 52.118 162 36.0001 145.882 36.0001 126 36.0001 106.118 52.118 90.0001 72 90.0001 91.882 90.0001 108 106.118 108 126Z",
    fill: "#4289C1",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessory191);
export default __webpack_public_path__ + "static/media/accessory19-1.d7046026e0ebf305f5000afbea947564.svg";
export { ForwardRef as ReactComponent };